/**
 * Utilidades de cuatrimestre (`term`) para el front-end.
 *
 * Formato de la etiqueta: `<AÑO><N>Q` con N ∈ {1, 2} (ej.: `20262Q`).
 *  - Enero–junio inclusive → `<AÑO>1Q`
 *  - Julio–diciembre inclusive → `<AÑO>2Q`
 *
 * IMPORTANTE: el front **no** calcula el cuatrimestre en curso (S1). Ese valor llega
 * siempre del backend (`GET /admin/users/terms` o `GET /submissions/my`), que lo deriva
 * de la fecha del servidor en TZ `America/Argentina/Buenos_Aires`. Calcularlo acá con
 * `new Date()` introduciría discrepancias de zona horaria con el servidor.
 */

export const TERM_REGEX = /^\d{4}[12]Q$/;

/** Cuatrimestre inmediatamente anterior. `20261Q` → `20252Q`. */
export function previousTerm(term: string): string {
  const year = Number(term.slice(0, 4));
  return term[4] === '1' ? `${year - 1}2Q` : `${year}1Q`;
}

/** Cuatrimestre inmediatamente posterior. `20262Q` → `20271Q`. */
export function nextTerm(term: string): string {
  const year = Number(term.slice(0, 4));
  return term[4] === '1' ? `${year}2Q` : `${year + 1}1Q`;
}

/** "20262Q" → "2026 2Q" */
export function formatTerm(term: string): string {
  return `${term.slice(0, 4)} ${term.slice(4)}`;
}

/**
 * Orden único de todo el proyecto (D5): más reciente primero.
 *
 * El orden lexicográfico invertido es correcto para este formato: todos los valores
 * tienen 6 caracteres, con el año en las primeras 4 posiciones y el dígito de
 * cuatrimestre en la quinta.
 */
export function sortTerms(terms: string[]): string[] {
  return [...new Set(terms)].sort().reverse();
}
